const zh_HK = {
    'name': 'data',
    // 首页
    'homePage': {
        'login': '登录繁体'
    },
    'errorCode': {
        'loading': '加載中...',
        'webCode503': '維護中',
        'webDefault': '請求錯誤',
        '4001': '調用遠程接口異常',
        '401': '您的登錄賬戶已經過期，請您重新登錄',
        '503': '系統維護中',
        '0': '成功！ ',
        '1': '失敗！ ',
        '500': '異常!',
        '1001': '登錄失敗，獲取token失敗',
        '1012': '網絡異常，請稍後再試！ ',
        '1101': '用戶未授權登錄',
        '1102': '用戶授權不匹配',
        '4011': 'redis鏈接異常',
        '4021': '短信發送失敗',
        '7001': '參數異常',
        '7002': '數據解析異常',
        '7011': '插入參數錯誤',
        '7101': '需要重新匯總的數據為空',
        '7102': 'Id不能為空',
        '7103': '當前ip為非CIDR格式',
        '7201': '初始化驗證碼失敗',
        '7202': '驗證碼校驗失敗,請重試',
        '7203': '驗證碼不能為空',
        '7204': '驗證碼發送過於頻繁',
        '7301': '該賬戶不存在或已被激活,請重新輸入',
        '7302': '該賬戶已被激活,請不要重複激活',
        '7303': '該賬戶正在激活中，請勿重複激活',
        '7304': '賬號不存在',
        '7305': '賬戶密碼錯誤，請重新輸入！ 3',
        '7306': '您的密碼修改次數已達上限，請聯繫客服處理！ ',
        '8000': '找不到相關數據',
        '9980': '活動尚未開始',
        '9981': '用戶層級不匹配',
        '9983': ' 名稱不能為空！ ',
        '9985': ' 層級信息異常！ ',
        '9987': ' 保存異常！ ',
        '9990': ' 自動審核條件設置異常，請確認後重試！ ',
        '9992': '操作已生效,請勿重複操作',
        '9993': '層級設置數據異常，請檢查層級設置後重試！ ',
        '9994': '未查詢到用戶信息',
        '9996': '用戶不滿足活動要求',
        '9997': '活動已過期',
        '10001': '活動尚未開始或已截止',
        '10002': '定時活動異常',
        '10003': '該活動只允許新註冊玩家參與',
        '10004': '您的會員層級不在活動允許參與範圍內',
        "10006": "活動獎勵領取時間尚未開始或已截止",
        '10031': '記錄的類型不能修改',
        '10032': '該記錄的跳轉類型不能修改',
        '10033': '該記錄的跳轉內容不能修改',
        '10034': '該記錄固定編碼不能修改',
        '10035': '該記錄不能刪除',
        '10036': '本活動自動領取最高獎勵，無需申請',
        '10062': '簽到異常用戶不滿足活動要求',
        '10091': '不參與廠商數據格式異常，數據格式為key-value格式',
        '10501': 'IP已經添加，無需再次添加',
        '10502': '當跳轉類型為外鏈的時候，跳轉內容必須以 http:// 或者 https:// 開頭！ ',
        '11001': '您的申請已提交，請等待客服聯繫',
        '11031': '至少添加一個層級',
        '11061': '該方案已被使用，無法關閉',
        '11091': '該代理賬號可能已被禁用，或被刪除，或者代理層級不是代理',
        '11501': '代理賬號名已存在，請重新填寫',
        '11531': '佣金配置詳情信息為空',
        '11801': '手機號加密失敗，請稍後再試',
        '12001': '獲取遊戲鏈接失敗',
        '12002': '獲取遊戲鏈接失敗',
        '12003': '刪除失敗，標籤下還存在遊戲',
        '12104': '該遊戲或者該廠商已被刪除',
        '12105': '該遊戲廠商尚未支持轉賬確認',
        '12208': '暫無獎池數據',
        '12501': 'queryType必須爲[vendor 或 tags 或 reportFee]其中一種',
        '12532': '起始時間為必填項',
        '12533': '起始時間大於結束時間',
        '12534': '起始時間大於60天',
        '12565': 'gameKindCode不能為空',
        '12566': 'user的id與member的id不匹配',
        '12592': '遊戲商不存在vendorCode',
        '12597': '廠商信息不能為空:',
        '13001': '用戶不存在',
        '13002': '用戶註冊時保存數據庫失敗',
        '13003': '用戶檢查失敗',
        '13004': '用戶狀態異常',
        '13006': 'member不存在',
        '13007': '您的賬號未綁定手機號碼，請聯繫客服處理',
        '13008': '該賬號已被凍結，請聯繫客服',
        '13009': '該賬號已被禁用，請聯繫客服',
        '13010': '由於版本更新您賬號超出字符限制，請聯繫在線客服處理',
        '130011': '用戶名或密碼錯誤請重新輸入,或聯繫客服處理',
        '130012': '用戶名已存在',
        '13501': '手機號已存在',
        '13502': '用戶名id不能為空',
        '13503': '手機號的用戶名沒有找到',
        '13801': '用戶註冊失敗',
        '13802': '用戶更新失敗',
        '13803': '遠程調用用戶更新失敗',
        '13901': '會員註冊設置異常，請聯繫客服！ ',
        '13902': '後台找回密碼次數限製配置錯誤',
        '14001': '用戶轉賬失敗',
        '14002': '自動轉賬失敗',
        '14003': '兩次稽核的值已經發生變化了',
        '14031': '訂單暫未鎖定，請先鎖定再操作',
        '14032': '該訂單已被其他人鎖定,您無法操作！ ',
        '14033': '訂單的狀態不符合要求！ ',
        '14034': '提交失敗，匯率已變動，請核對並確認金額後重新提交！ ',
        '14061': '提款申請已提交，請勿重複提交',
        '14062': '提款異常',
        '14091': '您已經綁定過此銀行卡',
        '14092': '銀行卡賬戶名不能為空',
        '14093': '綁定銀行卡已達到上限',
        '14094': '銀行卡姓名與你賬號的真實姓名不一致',
        '14095': '綁定數字錢包已經達到上限',
        '14096': '銀行卡暫時無法刪除，請聯繫客服處理，謝謝',
        '14097': '該銀行卡或數字錢包已被綁定,請重新輸入',
        '14098': '您的賬號被禁用，請聯繫客服人員！ ',
        '14099': '您的錢包賬戶被禁用，請聯繫客服人員！ ',
        '14100': '您輸入的賬號有誤，請聯繫客服人員！ ',
        '14101': "請輸入長度為6位數字的錢包ID號，謝謝",
        '14501': '存款人不能為空',
        '14502': '支付平台編碼和名稱為必填項',
        '14503': '錢包用戶沒有找到',
        '14504': '您的單次提款金額低於下限：',
        '14505': '您的單次提款金額高於上限：',
        '14506': '存款金額必須大於零',
        '14801': '更新失敗',
        '14901': '支付密鑰沒有設置',
        '14902': '獲取支付列表的URL沒有設置',
        '14903': '獲取同步訂單的URL沒有設置',
        '14904': '訂單回調的URL沒有設置',
        '14905': '數字貨幣的充值回調CALLBACK沒有設置',
        '14906': '該商戶的支付密鑰沒有設置',
        '14907': '支付相關的字典設置出錯了',
        '15001': '領取失敗',
        '15002': '領取異常',
        '15034': '獲取租戶信息異常',
        '15035': '數據已被更改，手動回滾事務',
        '15061': '全民返利功能尚未開啟',
        '15062': '未領取返利金額小於最低領取額度',
        '15063': '請勿重複提交',
        '15064': '正在領取返水中',
        '15091': '餘額正在歸集，不予查詢！ ！ ！ ',
        '15121': '錢包服務異常',
        '15151': '訂單已經處理過',
        '15181': '清理凍結失敗',
        '15501': '轉賬金額必須大於1',
        '15502': '轉賬金額必須大於0',
        '15503': '轉賬模式不是合法值',
        '15504': '凍結餘額不足',
        '15801': '中心錢包轉入到遊戲商失敗！ ',
        '15802': '遊戲商轉出到中心錢包失敗！ ',
        '15901': '返水未配置',
        '16001': '平台維護',
        '16002': '平台不存在',
        '16003': '賬號已在其它設備登錄，請重新登錄',
        '100661': '您的簽到請求已發送，請勿重複提交',
        '110004': 'Token 無效！ ',
        '110007': '用戶未授權登錄！ ',
        '110009': '當前ip受限',
        '110010': '請求過於頻繁，請稍後再試',
        '120001': '該商戶不存在',
        '120004': '請求參數中存在null',
        '120014': '用戶的中心錢包不存在',
        '120017': '會員等級不存在',
        '120021': '訂單號已經存在：',
        '120024': '訂單信息不匹配',
        '120025': '支付模式不匹配',
        '120026': '訂單狀態已經為最終狀態,您無法操作！ ！ ',
        '120027': '您上一次提款未處理完，請耐心等待！ ',
        '120029': '訂單需要風控審核通過，您才能操作！ ',
        '120031': '您的每日提現次數已經用完：',
        '120032': '錢包已被禁用，請聯繫客服！ ',
        '120050': '嚴重警告：該用戶的密值不匹配',
        '120051': '您的餘額不足，無法提現！ ',
        '120055': '生成密值時發生錯誤',
        '120056': '您的提款密碼錯誤！ ',
        '120057': '更新錢包數據失敗version不匹配',
        '120070': '用戶的餘額不足',
        '120093': '獲取頻繁，請稍後再試！ ！ ！ ',
        '120561': '您填寫的邀請碼有問題(代理用戶不存在，或尚未啟用),請核實後重新提交申請',
        '130000': '該幣種在鏈路上的匯率沒有找到,請更換幣種',
        '999999': '支付異常',
        '1000': '未知錯誤',
        '130013': '原密碼錯誤，修改失敗'
    },
    // 首页 
    'indexPage': {
        noMoreTipToday: '今日不再提示',
        'notice': '系統公告',
        'discount': '優惠活動',
        'more': '更多',
        'disIntro': '電子鴻運當頭 做任務天天獎',
        'viewDis': '查看優惠',
        'enterLobby': '進入大廳',
        'casino': '電子遊藝',
        'live': '真人娛樂',
        'fish': '捕魚游戲',
        'chess': '棋牌',
        'reviewReward': '大獎回顧',
        'startGame': '開始遊戲',
        'tryOnce': '試玩體驗',
        'noshow': '不再顯示',
        'newVersion': '新版澳門金沙APP搶先下載！ ',
        'text2': '防劫持下載、教程，拒絕虛假詐騙',
        'text3': '存款操作演示',
        'text4': '澳門金沙官方APP下載，隨心所欲自由暢玩',
        'detail': '✿尊敬的澳門金沙會員，一直有不法分子冒用“澳門金沙”的名義，採取虛假效仿網站、釣魚網站、App網頁攔截，微信公眾號等方式進行誘騙，請大家千萬不要上當受騙，以免造成損失。澳門金沙再三申明，絕無其他合作公司或子公司，也沒有和任何其他公司合併。網站所有優惠都以官網為準。如有任何疑問，請聯繫客服諮詢！ ',
        'gongxi': '恭喜會員',
        'zai': '在',
        'zhongjiang': '中獎',
        'yuan': '元',
        'pleaseLogin': '請登錄',
        'repair': '維護中',
        'failed': '進入遊戲失敗，請稍後重試！ ',
    },
    // 二级游戏
    'secondGame': {
        'intro1': '現場360度視角，推薦最好牌路',
        'intro2': '多桌同時投注，讓您樂在其中',
        'intro3': '獨創6張牌先發，多種創新玩法',
        'intro4': '獨創真人、電遊同廳共玩',
        'input': '請輸入遊戲名稱',
        'newReward': '最新中獎',
        'hot': '熱門推薦',
        'member': '會員',
        'reward': '中獎',
        'enter': '進入遊戲',
        'nothing': '當前輸入為空',
        'pleaseLogin': '請登錄',
    },
    // 大獎回顧
    'prize': {
        'yuan': '元',
        'million': '百萬紅包',
        'like': '喜氣紅包',
        'bet': '投注金額',
        'rewrad': '暴獎金額',
    },
    'enterGame': {
        'pleaseLogin': '請登錄',
    },
    homeIndex: {

        // 各个标题

        hotgamemaintitle: '熱門遊戲',
        hotgamesecondtitle: '精選熱門遊戲，每天暢享不斷',

        casinomaintitle: '電子遊藝',
        casinosecondtitle: '帶給你豐富的遊戲體驗',

        chessmaintitle: '棋牌娛樂',
        chesssecondtitle: '帶給你豐富的遊戲體驗',

        citymaintitle: '娛樂城',
        citysecondtitle: '帶給你豐富的遊戲體驗',

        coomaintitle: '合作專區',
        coosecondtitle: '優質服務 安全快捷',

        hot: '熱門',
        recommend: '推薦',
        hotUsual: '常玩',

        sportCom: '體育賽事',
        liveDealer: '視訊直播',
        esportCom: '電競賽事',
        lotteryCom: '彩票遊戲',

        sportComCon: '足球、籃球、網球、羽毛球等體育項目 擁有獨特的玩法和精準的賠率!',
        liveDealerCon: '更具真實的玩法，更加真實的場景。給你帶來極具刺激的真人遊戲。 ',
        esportComCon: '世界上最全面的電競賽事競猜，讓您無時無刻體驗到電競盛宴。 ',
        lotteryComCon: '彩票的感官刺激，種類繁多的彩票遊戲邀您一起體驗!',

        downApp: 'APP下載',
        actDis: '優惠活動',
        cooper: '合作專區',
        online: '在線客服'
    },
    // 登錄
    "loginPage": {
        'memberLogin': '用戶登錄', // 登錄
        'login': '用户登錄', // 登錄
        'account': '賬號',
        'password': '密碼',
        'verifyCode': '驗證碼',
        'accountP': '請輸入賬號', // 請輸入賬號
        'passwordP': '請輸入登錄密碼', // 請輸入登錄密碼
        'verifyCodeP': '請輸入驗證碼', // 請輸入圖形驗證碼
        'fastRegister': '註冊', // 註冊
        'retrievePassword': '找回密碼', // 找回密碼
        'regain': '重新獲取', // 重新獲取
        'accountE': '賬號不能為空', // 賬號不能為空
        'passwordE': '密碼不能為空', // 密碼不能為空
        'verifyCodeE': "驗證碼不能為空",
        'firstVerify': "請先通過行為驗證", // 請先通過行為驗證
        'loginSuccess': "恭喜您，登錄成功", // 登錄成功
        'passwordLeak': '您的登錄密碼已確認，請及時修改密碼，以防洩露！ ', // 您的登錄密碼已確認，請及時修改密碼，以防洩露！
        'gotIt': "知道了",
        'logExceptionVerifyFront': '您的驗證信息錯誤，還有', // 您的驗證信息錯誤，還有
        'logExceptionVerifyBack': '次驗證機會，超過次數會凍結賬號哦！ ', // 次驗證機會，超過次數會凍結賬號哦！
        'clickBtnToVerify': "點擊按鈕驗證",
        'loading': "正在加載...",
        'verifySuccess': '驗證成功',
        'verifyFail': '驗證失敗',
        'getError': '獲取錯誤',
        'loadFail': '加載失敗，請重試',
        'notAccount': "還沒有賬號？", //還沒有賬號？
        'fastRegister': '立即註冊', //立即註冊

    },
    // 異常登錄驗證
    'validLoginPage': {
        'title': '異常驗證',
        'desc': "系統檢測到您的賬戶登錄地區異常，請填寫你的賬戶真實姓名進行驗證！",
        'realName': '姓名',
        'realNameP': "請輸入姓名",
        'submitBtn': "提交驗證"
    },
    // 註冊
    "registerPage": {
        'memberRegister': '會員註冊',
        'register': "免費開戶",
        'confirmPsw': "確認密碼",
        'inviteCode': '邀請碼',
        'phone': '手機號',
        'birthday': '生日',
        'wechat': '微信',
        'qq': 'QQ',
        'email': '郵箱',
        'address': '地址',
        'inviteCodeP': '請輸入邀請碼',
        'optional': '（選填）',
        'phoneP': '請輸入手機號碼',
        'realNameP': '請輸入姓名',
        'sexP': '請選擇性別',
        'male': '男',
        'female': '女',
        'birthdayP': '請輸入生日',
        'wechatP': '請輸入微信號碼',
        'qqP': '請輸入QQ號碼',
        'emailP': '請輸入郵箱地址',
        "addressP": '請輸入聯繫地址',
        "agree": '已經滿18周歲，並且同意本站',
        'userAgreement': '《用戶使用協議》',
        'haveAccount': '已有賬號？ ',
        'fastLogin': '立即登錄',
        'sex': "性別",
        'cancel': "取消",
        'confirm': '確定',
        'inviteCodeE': '邀請碼不能為空！ ',
        'confirmPswE': '確認密碼不能為空！ ',
        'phoneE': '手機號不能為空！ ',
        'realNameE': '姓名不能為空！ ',
        'birthdayE': '生日不能為空！ ',
        'wechatE': '微信號不能為空！ ',
        'qqE': 'QQ號不能為空！ ',
        'emailE': '郵箱不能為空！ ',
        'addressE': '地址不能為空！ ',
        'codeE': '驗證碼不能為空！ ',
        'firstAgree': '請先勾選用戶使用協議！ ',
        'inviteCodeV': '邀請碼必須為字母或數字',
        'accountV': '賬號必須為4~15位數字與字母組合',
        "accountPostV": "賬號必須為4~13位數字與字母組合",
        'passwordV': '密碼必須為6-15位字母或數字',
        'pswIscPsw': '密碼與確認密碼必須一致',
        'phoneV': '手機格式不正確',
        'wechatV': '微信號碼不存在！ ',
        'qqV': 'QQ號碼不存在！ ',
        'emailV': '郵箱地址不存在！ ',
        'registerSuccess': "恭喜您，註冊成功",
        'inviteCodeF': '請輸入字母或數字'
    },
    // 忘記密碼
    'forgetPswPage': {
        'retrievePassword': '找回密碼',
        'firstStep': '第一步:驗證賬號信息',
        'isRetrievePassword': "有問題？請聯繫",
        'onlineService': '在線客服',
        'confirmToSubmit': "確認提交",
        'secStep': "第二步:短信驗證",
        'SMSCodeP': "請輸入短信驗證碼",
        'getCode': "獲取驗證碼",
        'thirdStep': '第三步:修改新密碼',
        'newPsw': '新密碼',
        'newPswP': '請輸入新密碼',
        'reNewPswP': "請再次輸入新密碼",
        'codeE': '驗證碼不能為空',
        'Tips': '溫馨提示',
        'gotIt': '知道了',
        'phoneCodeE': "短信驗證碼不能為空！",
        'newPswE': "新密碼不能為空！",
        'newPswValid': '新密碼必須為6-15位字母或數字',
        'newIsConfirmPsw': '新密碼與確認密碼必須一致',
        'modifySuccess': '修改成功，5S後進入登錄界面',
        'enterLogin': '進入登錄頁',
        'modifySuccessA': "修改成功，",
        'aEnterLogin': 'S後進入登錄界面'
    },
    // 個人資料頁面
    'personalPage': {
        'personalData': '個人資料',
        'nickname': '暱稱',
        'nicknameP': '請輸入暱稱',
        'submit': '提交',
        'accountPsw': '賬號密碼',
        'tradePsw': '交易密碼',
        'modify': '修改',
        'set': '設置',
        'updateSuccess': "更新會員成功",
        'birthdayP': '年/月/日',
        'phone': "聯繫電話",
        'email': "郵箱地址",
        'qq': "聯繫QQ"
    },
    //代理首页
    'agentHome': {
        'title': "合作專區",
        'advantage': '大優勢 讓你不可抗拒',
        'titleDesc': '優質服務 安全快捷',
        'desc': '亞洲頂級線上博彩公司，最具公信力，更具高端品質，深受廣大玩家喜愛及支持，同時致力於打造線上最高端的代理合作平台，零成本，高回報。為“微商、電商”爭相選擇之最佳創業投資項目。加入我們，開啟您的財富夢想之路！ ',
        'lang_1': '八大優勢讓你不可抗拒',
        'lang_21': "高達50%的代理佣金",
        'lang_22': "足不出戶月入百萬",
        'lang_31': "每月準時出傭",
        'lang_32': "零風險,零費用,高回報",
        'lang_41': "全年度優惠不斷",
        'lang_42': "滿足各種類型玩家需求",
        'lang_51': "提款快速，金額不封頂",
        'lang_52': "實力雄厚，資金有保障",
        'lang_61': "數據信息詳盡",
        'lang_62': "投注/資金各種數據",
        'lang_71': "視訊、電子遊藝、體育、彩票",
        'lang_72': "線上賭場執照，信譽保證",
        'lang_81': "多年大力推廣",
        'lang_82': "代理可坐享廣告品牌效應",
        'lang_91': "品質卓越，服務到位",
        'lang_92': "深受百萬玩家信賴",
        'lang_2_title': '50% 代理佣金',
        'lang_3_title': '安全 可靠',
        'lang_4_title': '優惠 不斷',
        'lang_5_title': '資金 雄厚',
        'lang_6_title': '全面 數據服務',
        'lang_7_title': '線上 執照',
        'lang_8_title': '品牌 熱度十足',
        'lang_9_title': '運營 多年平台 穩定',
        'lang_commissionPlan': "代理佣金方案",
        'lang_joinUs': "加入我們",
        'lang_contactService': "加盟請諮詢客服",
        'commissionTitle': "代理佣金方案",
        'contactUs': "聯繫我們"
    },
    // 代理註冊
    'agentRegister': {
        'title': "代理申請",
        'lang_accountP': "請輸入申請賬號",
        'lang_passwordP': '請輸入賬戶密碼',
        'lang_rePasswordP': "請再次輸入賬戶密碼",
        'lang_fastApply': '立即加入',
        'agreement': "加盟協議",
        'accountPostF': '請輸入4~13位數字與字母組合',
        'accountF': '請輸入4~15位數字與字母組合',
        'passwordF': '請輸入6-15位字母或數字'
    },
    // 提交成功
    'agentResult': {
        'applySubmited': "申請已提交，",
        'contactAttache': '請在3日內與專員聯繫開通，並提供您的代理編號和代理鏈接。 '
    },
    // 加盟協議
    'agreement': {
        'lang_title': "【加盟協議】",
        'lang_para1': "一、遊戲平台對代理聯盟的權利與義務：",
        'lang_para11': "遊戲平台客服部會登記聯盟的會員並會觀察他們的投注狀況。聯盟及會員必須同意並遵守遊戲平台的會員條例，政策及操作程式。遊戲平台保留拒絕或凍結聯盟/會員帳戶權利。",
        'lang_para12': "代理聯盟可隨時登入介面觀察旗下會員的下注狀況及會員在網站的活動概況。遊戲平台的客服部會根據代理聯盟旗下的會員計算所得的佣金。",
        'lang_para13': '遊戲平台保留可以修改合約書上的任何條例，包括: 現有的佣金範圍、佣金計劃、付款程式、及參考計劃條例的權力，遊戲平台會以電郵、網站公告等方法通知代理聯盟。代理聯盟對於所做的修改有異議，代理聯盟可選擇終止合約，或洽談客服人員反映意見。如修改後代理聯盟無任何異議，便視作默認合約修改，代理聯盟必須遵守更改後的相關規定。 ',
        'lang_para2': "二、代理聯盟對遊戲平台的權力及義務：",
        'lang_para21': '代理聯盟應盡其所能，廣泛地宣傳、銷售及推廣遊戲平台，使代理本身及遊戲平台的利潤最大化。代理聯盟可在不違反法律下，以正面形象宣傳、銷售及推廣遊戲平台，並有責任義務告知旗下會員所有遊戲平台的相關優惠條件及產品。 ',
        'lang_para22': "代理聯盟選擇的遊戲平台推廣手法若需付費，則代理應承擔該費用。",
        'lang_para23': "任何遊戲平台相關資訊包括: 標誌、報表、遊戲畫面、圖樣、文案等，代理聯盟不得私自複制、公開、分發有關材料，遊戲平台保留法律追訴權。 如代理在做業務推廣有相關需要，請隨時洽遊戲平台。",
        'lang_para3': "三、規則條款：",
        'lang_para31': "各階層代理聯盟不可在未經遊戲平台許可情況下開設雙/多個的代理帳號，也不可從遊戲平台帳戶或相關人士賺取佣金。請謹記任何階層代理不能用代理帳戶下注，遊戲平台有權終止並封存帳號及所有在遊戲中賺取的佣金。",
        'lang_para32': "為確保所有遊戲平台會員賬號隱私與權益，遊戲平台不會提供任何會員密碼，或會員個人資料。各階層代理聯盟亦不得以任何方式取得會員資料，或任意登入下層會員賬號，如發現代理聯盟有侵害遊戲平台會員隱私行為，遊戲平台有權取消代理聯盟紅利，並取消代理聯盟賬號。",
        'lang_para33': "代理聯盟旗下的會員不得開設多於一個的帳戶。遊戲平台有權要求會員提供有效的身份證明以驗證會員的身份，並保留以IP判定是否重複會員的權利。如違反上述事項，遊戲平台有權終止玩家進行遊戲並封存帳號及所有於遊戲中賺取的佣金。",
        'lang_para34': "代理聯盟不可為自己或其他聯盟下的有效投注會員,只能是公司直屬下的有效投注會員, 代理每月需有3個下線有效投注會員（每月至少上線3次進行正常投注），如有違反聯盟協議遊戲平台有權終止並封存帳號及所有在遊戲中賺取的佣金。",
        'lang_para35': "如代理聯盟旗下的會員因為違反條例而被禁止享用遊戲平台的遊戲，或遊戲平台退回存款給會員。 合約內的條件會以遊戲平台通知接受代理聯盟加入後開始執行。遊戲平台及代理聯盟可隨時終止此合約，在任何情況下，代理聯盟如果想終止合約，都必須以書面/電郵方式提早於七日內通知遊戲平台。 代理聯盟的表現會3個月審核一次，如代理聯盟已不是現有的合作成員則本合約書可以在任何時間終止。如合作夥伴違反合約條例，遊戲平台有權立即終止合約。",
        'lang_para36': "在沒有遊戲平台許可下，代理聯盟不能透露及授權遊戲平台S相關密資料，包括代理聯盟所獲得的回饋、佣金報表、計算等;代理聯盟有義務在合約終止後仍執行機密檔及資料的保密。在合約終止後，代理聯盟及遊戲平台將不須要履行雙方的權利及義務。終止合約並不會解除代理，聯盟於終止合約前應履行的義務。"
    },
    // 公告消息
    'noticeInfo': {
        'title': '公告消息',
        'msgDetailTitle': '通知詳情',
        'noticeDetailTitle': '公告詳情',
        'messageNavTitle': '站內信',
        'noticeNavTitle': '公告',
        'deleteAll': '全部刪除',
        'readedAll': '全部已讀',
        'msgEmpty': '一條通知都沒呢...',
        'noticeEmpty': '一條公告都沒呢...',
        'delete': '刪除',
        'back': '返回',
        'msgAllDeleteSuccess': '通知全部刪除成功!',
        'msgAllReadSuccess': '通知全部已讀成功!',
        'msgDeleteSuccess': '通知刪除成功!',
        'tip': "溫馨提示: 站內信的消息每週一上午10點會自動清除前2週記錄！",
        'sectionTitle': "標題",
        'time': '時間',
        'status': '狀態',
        'operation': '操作',
        'unread': '未讀',
        'readed': "已讀"
    },
    // 优惠活动页面
    "activityPage": {
        'return': '返回',
        'title': '活動中心',
        'longTime': '長期活動',
        'limitTime': '限時活動',
        'activityTime': '活動時間',
        'ThereNOdata': '沒有更多數據了',
        "actDetail": '活動詳情',
        "actcomputed": '活動完成情况',
        "lookList": '查看活動記錄',
        "actList": '活動記錄',
        "yuan": '元',
        "ongoing": '進行中',
        "unfinished": '未完成',
        "WaitingAudit": '等待稽核',
        "complete": '已完成,獎勵已發放至中心錢包',
        'Immediately': '立即參與',
        'Contactcustomer': '聯系客服',
        'date': '日期',
        "theConditions": '完成條件',
        'completion': '完成狀態',
        "month": '月',
        'day': '日',
        "Participate": '參與成功',
        'notapproved': '稽核未通過',
        'Loading': '正在加載...',
        'ThereNOdata': '沒有更多數據了',
        'Pullmore': '下拉顯示更多',
        'status': '活動狀態',
        "actend": '活動截止',
        'actShuo': '活動說明',
        'title1': '全部優惠',
        'title2': '限時活動',
        'title3': '長期活動',
        'title4': '永久',
        'title1': '關閉',
        'hotAct': '熱門活動',
    },
    // 彩金页面
    "lotteryGold": {
        "LotterCollection": "彩金",
        "all": '全部',
        "available": '可領取',
        "Received": '已領取',
        "Expired": '已過期',
        "getnow": '立即領取',
        "effective": '領取有效期截止',
        "nodata": '暫無數據',
        "flowdemand": '流水要求',
        "bei": '倍',
        "prompt": '提示',
        "succeeded": '領取成功',
        "toSee": '請前往餘額查看',
        "Isee": '我知道了',
        "beencollected": '彩金已經領取過啦',
        "unableClaim": '已過期無法領取！',
        "LotterCo": "彩金領取",
        'Loading': '正在加載...',
        'ThereNOdata': '沒有更多數據了',
        'Pullmore': '下拉顯示更多',
        'cancel': '取消'
    },
    // 安全中心頁面
    'safetyPage': {
        'Usersecurity': '用戶安全',
        'loginPassword': '登錄密碼',
        'Tomodify': '去修改',
        'WithdPassword': '取款密碼',
        'Tosettings': '去設置',
        'OriginalPassword': '請輸入原登錄密碼',
        'withdrawalPassword': '請輸入原取款密碼',
        'EnterOldPassword': '請輸入原密碼',
        'Newloginpassword': '請輸入新登錄密碼',
        'Newwithpassword': '請輸入新取款密碼',
        'Enternewpassword': '請輸入新密碼',
        'Confirmnewpassword': '確認新密碼',
        'EnterPasswordAgain': '請再次輸入密碼',
        'SetPassword': '設置密碼',
        "ConfirmPassword": '確認密碼',
        'Newphonenumber': '新手機號',
        'enternewnumber': '請輸入新手機號碼',
        'VerificationCode': '驗證碼',
        'entercode': '請輸入驗證碼',
        'GetCaptcha': '獲取驗證碼',
        'confirm': '確認',
        'Confirmsubmit': '確認提交',
        'Pleasecontact': '有問題？請聯繫',
        'OnlineService': '在線客服',
        'Changepassword': '修改登錄密碼',
        'Modifywithdpassword': '修改交易密碼',
        'Setwithdpassword': '設置交易密碼',
        'Modifyphonenumber': '修改手機號碼',
        'Modifysucceeded': '修改成功',
        'Setupsucceeded': '設置成功',
        'originalpassword': '原密碼必須為6-15位字母或數字！ ',
        'originalwithdrawal': '原取款密碼必須為6位數字',
        'newwithdrawal': '新取款密碼必須為6位數字',
        'newwithdrawal11': '確定密碼必須為6位數字或數字',
        'passwordcannotempty': '原密碼不可為空',
        'notthesame': '兩次輸入的密碼不一致',
        'Newpassword': '新密碼必須為6-15位字母或數字！ ',
        'Failednumber': '綁定手機號失敗',
        'Bindsuccessfully': '手機號綁定成功',
        'Mobileempty': '手機號不可為空',
        'IncorrectPhone': '手機格式不正確',
        'Failedtocode': '獲取手機驗證碼失敗',
        'codecomplete': '獲取手機驗證碼完成',
        'Pageupdate': '頁面更新',
        'Modifysucceeded': '修改成功',
        'newPass': '新密碼',
        "oldPass": '原密碼',
        'agagin': '再次輸入',
        'Loginsuc': '修改登入密碼成功',
        "Transactionsuc": '設定交易密碼成功',
        'ransactionsuc': '修改交易密碼成功',
        'tip': '溫馨提示：修改後請牢記您的資金密碼。 ',
        'tip1': '當前您所使用的資金密碼',
        'tip2': '6位數字組合',
        'tip3': '必須與新密碼一致',
        'tip4': '密碼必須為6數字！ ',
        'tip5': '當前您所使用的登錄密碼',
        'tip6': '6-15位英文和數字組合',
        'tip7': '溫馨提示：修改後請牢記您的登錄密碼。 ',
        'tip9': '忘記密碼',
        "tip10": '您的賬戶安全等級',
        "tip11": '還有',
        "tip12": '項未通過驗證/設定',
        "tip13": '資金密碼',
        "tip14": '銀行卡綁定後，提款操作時需要進行資金密碼確認，以提高您的資金安全性。 ',
        "tip15": '綁定郵箱',
        "tip16": '修改',
        "tip17": '設置',
        "tip18": '綁定郵箱',
        "tip19": '綁定郵箱可增加賬號安全級別，也可以確保在郵箱正常的情況下取回登錄密碼。 ',
        "tip20": '綁定手機',
        "tip21": '與您的賬號綁定後，在資金提現、修改密碼等重要時刻，可以加強您的賬號安全。 ',
        "tip22": '綁定QQ',
        "tip23": '請聯繫客服進行修改！ ',
        "tip24": '低級',
        "tip25": '高級',
        "tip26": '中等',
        'tip27': '已綁定',
        'tip28': '未綁定',
        'tip29': '安全驗證',
        'tip30': '資金密碼',
        'tip31': '登錄密碼',

    },
    // 签到
    "signIn": {
        'limitTime': '限時優惠',
        'noShow': '不再彈出此提示',
        "signIn": '簽到',
        "actTime": '活動時間',
        "to": '至',
        "di": '第',
        "day": '天',
        "Signnow": '立即參與',
        "Checkin": '簽到領取',
        "requirements": '流水要求',
        "bei": '倍',
        "gitNow": '立即領取',
        "tip": '提示',
        "success": '領取成功,請前往餘額查看',
        "Isee": '我知道了',
        "actDet": '活動說明',
        "loading": '加載中',
        'long': '長期',
        'cancel': '取消',
        'lianxu': '您已連續簽到',
    },

    "myPage": {
        "recharge": "財務中心",
        "drawing": "交易記錄",
        "highRebate": "全民返利",
        "information": "個人資料",
        "mode": "自助優惠",
        "report": "遊戲記錄",
        "security": "交易記錄",
        "Notice": "公告消息",
        "cooperation": "活動記錄",
        "gle": "安全管理",
        "withdrawals": "彩金管理",
        "Deposit": "會員存款",
        treasure: "利息寶",
        Rebate: "返利",
        bank: '收款方式管理',
        drawing: '會員提款',
        userInfo: '基本信息',
        complete: '完善資料',
        "water": "累計返水",
        "element": "元",
        "full": "滿",
        "rec": "元可領取",
        "receive": "領取",
        "getBackwater": "返水領取",
        "once": "立即領取",
        "see": "查看詳情",
        "tipErr": "返水額度不滿足條件，無法領取！",
        "tipstitle": "溫馨提示",
        "know": "我知道了",
        titleAlert: '領取成功',
        "tipsRes": "請到中心錢包查看餘額",
        "success": "返水刷新成功",
        "failure": "返水額度刷新失敗，請重試！",
        requirements: "流水要求",
        Times: "倍",
        get: "領取"
    },
    "drawingPage": {
        "headerTitle": "取款",
        "getbank": "提款銀行卡",
        "getMoney": "提款金額",
        "all": "全部",
        "sure": "當前可提現金額",
        "element": "元",
        "actual": "實際到賬金額",
        "refresh": "刷新",
        "procedures": "提現手續費",
        "expenses": "行政費用",
        "discount": "優惠扣除",
        "pawss": "交易密碼",
        "inputPwass": "請輸入交易密碼",
        "problem": "有問題？請聯繫在線客服",
        "withdrawal": "確認提款",
        "selectBank": "選擇銀行",
        "inputMoney": "請輸入提款金額",
        "integer": "提款金額必須為正整數",
        "confirmation": "是否確認提款？",
        "cancel": "取消",
        "determine": "確定",
        "successful": "申請成功，請等待平台審核",
        "fail": "提款失敗請重試",
        "beyond": "金額超限，請輸入正確金額",
        "currency": "數字貨幣錢包",
        "wallet": "origo錢包",
        "getpwass": "找回密碼",
        "selecurrency": "選擇數字貨幣",
        "Insufficient": "您的餘額不足，無法提現！",
        "lower": "您的取款額度低於單次取款限額:",
        "higher": "您的取款額度高於單次取款限額",
        "toolow": "您的實際獲得額度過低，無法提現！",
        "minAmount": "最小提現金額",
        'gotIt': '知道了',
        'sucRefresh': '刷新成功',
        "tip": '提示',
        "tips1": "1.請注意頁面顯示的最小轉賬額度，小於最小充值金額的充值將不會上賬且無法退回；",
        "tips2": "2.您充值至上述地址後，需要整個網絡節點的確認，請耐心等待，我們收到數字貨幣後會立即向您的賬戶上賬對應金額，若長時間未收到，可聯繫客服諮詢",
        "tips3": "3.轉賬時請務必核對幣種以及鏈名稱，若提交錯誤資產不可找回。",
        "tips4": "4.頁面顯示匯率只供參考，由於匯率存在波動，上賬時將根據最新的匯率比例進行計算。",
        mode: '取款方式',
        goback: '上一步',
        errorTips: '您的錢包已被凍結，請聯繫客服！ ',
        nullbank: '未添加銀行卡',
        now: '現在添加'
    },
    // 存取款 recharge
    "rechargePage": {
        "headerTitle": "存款",
        "null": "暫時沒有該存款方式",
        getMode: '支付方式',
        "passageway": "充值通道",
        "seleBank": "選擇銀行",
        "name": "存款姓名",
        'address': '存款地址',
        'addressPlaceholder': '請輸入存款地址',
        'tipsAddress': '為確保及時到賬，請務必輸入正確的存款地址',
        "tipsName": "為確保及時到賬，請務必輸入正確的存款姓名",
        "inputName": "請輸入存款姓名",
        "setmoney": "充值金額",
        "inputMoney": "請輸入存款金額",
        "minMoney": "單筆最低入款金額",
        "element": "元",
        "maxMoney": "最高入款金額",
        "tipstitle": "溫馨提示",
        "tips1": "1.請注意頁面顯示的最小轉賬額度，小於最小充值金額的充值將不會上賬且無法退回；",
        "tips2": "2.您充值至上述地址後，需要整個網絡節點的確認，請耐心等待，我們收到數字貨幣後會立即向您的賬戶上賬對應金額，若長時間未收到，可聯繫客服諮詢",
        "tips3": "3.轉賬時請務必核對幣種以及鏈名稱，若提交錯誤資產不可找回。",
        "tips4": "4.頁面顯示匯率只供參考，由於匯率存在波動，上賬時將根據最新的匯率比例進行計算。",
        "confirm": "確認充值",
        "next": "下一步",
        "setparagraph": "公司入款",
        "online": "線上入款",
        "currency": "數字貨幣",
        "vip": "VIP專享",
        "tipsnull": "當前無充值信息，請聯繫客服！",
        "gotIt": "知道了",
        "determine": "確定",
        "range": "金額輸入不在範圍",
        "retry": "該通道不可用請重試",
        "error": "錯誤碼",
        "bankSelect": "請選擇銀行卡",
        errortext: '加載失敗',
        tipsMoney: '溫馨提示: 如當前支付方式未能支付成功，請您嘗試其他支付方式進行支付！ ',
    },
    // 提款
    "accountPage": {
        "headerTitle": "取款",
        "balance": "賬戶餘額",
        "element": "元",
        "collection": "一鍵歸集",
        "getMode": "請選擇提款方式",
        "tipsnull": "一張銀行卡都沒有呢",
        "addMode": "添加取款方式",
        "addbank": "添加銀行卡/數字貨幣",
        "addMoney": "添加數字貨幣錢包",
        "cancel": "取消",
        "more": "更多",
        "down": "下拉刷新",
        "away": "收起",
        "warning": "點擊間隔10s，請勿重複操作！",
        "Refresh": "刷新余額成功",
        "hand": "歸集中",
        "handRes": "歸集成功！",
        "handErr": "歸集失敗，請重新嘗試！",
        "setpassword": "您還未設置交易密碼， 是否前往設置？",
        "forward": "立即前往",
        "tipsbank": "您最多只能綁3張銀行卡！如需調整，請聯繫客服！",
        "tipsM": "您最多只能綁3種數字貨幣！如需調整，請聯繫客服！",
        "tipsW": "您最多只能綁3個origo錢包！如需調整，請聯繫客服！",
        "addWallet": "添加origo錢包",
        wallet: "origo錢包",
        next: '下一步',
        phoneget: '請驗證手機號提款',
        phone: '手機號',
        inputPhone: '請輸入手機號',
        inputcode: '請輸入驗證碼',
        code: '驗證碼',
        determine: '確定',
        getcode: '獲取驗證碼',
        getmoneyMode: '收款方式',
        phoneErr: '手機號格式錯誤',
        getcodeSuee: '獲取驗證碼成功',
        'mobile': '綁定手機號成功',
        game: '遊戲平台',
        accountMoney: '主賬戶額度'
    },
    // 銀行卡列表
    "bankCardPage": {
        "title": "收款方式管理",
        "tipnull": "這裡空空的 \n 什麼都沒有",
        "addMethod": "我的銀行卡",
        "addBank": "添加銀行卡/數字貨幣",
        "addMoney": "添加數字貨幣",
        "wallet": "添加origo錢包",
        "wallets": "origo錢包",
        "addBankmode": "收款方式",
        "username": "賬戶姓名",
        "inputName": "請輸入賬戶姓名",
        "bankName": "銀行名稱",
        "bankCode": "銀行卡號",
        "inputCode": "請輸入您的新銀行卡號",
        "tipsCode": "銀行卡號必須大於12位小於19位",
        "branch": "支行名稱",
        "inputbranch": "請輸入支行名稱",
        "Submit": "確認提交",
        "getcode": "獲取驗證碼",
        "selectBank": "請選擇銀行",
        "selectBank1": "選擇銀行",
        "determine": "確定",
        "addRes": "添加成功",
        "addTitle": "數字貨幣",
        "type": "選擇幣種",
        "name": "鏈名稱",
        "adress": "錢包地址",
        "add": "確認添加",
        "seleType": "請選擇幣種類型",
        "tipName": "請填寫真實姓名再添加銀行卡",
        "tipsPawss": "請先設置取款密碼再添加銀行卡",
        "again": "重新添加",
        "input": "請輸入",
        "pType": "請選擇幣種",
        "inputAddress": "請輸入錢包地址",
        "linkAddress": "請輸入鏈地址",
        "account": "origo錢包賬戶",
        "inputWallet": "請輸入錢包賬戶",
        "tips": "提示",
        tips1: '為了您的資金能迅速到賬，請確保選擇的貨幣名稱與鏈名稱正確無誤',
        tips2: '為了您的資金迅速到賬，請確保填寫姓名與銀行開戶姓名一致',
        addMode: '添加收款方式',
        bankcard: '銀行卡',
        cancel: '取消',
        code2: '確認卡號',
        bankcode2: '請再次輸入您的銀行卡號',
        bankcode3: '由12-19位數字組成',
        back: '返 回',
        text1: '不可重複添加相同的銀行',
        text2: '不可重複添加相同的錢包',
        tips: '溫馨提示：鎖定銀行卡後，不可修改銀行相關信息（開戶姓名無法修改，否則無法提款!）',
        errCode: '兩次輸入銀行卡號不一致',
        errwalletcode: '請輸入長度為6位數字的錢包ID號，謝謝',
        origo: '點擊這裡下載origo錢包'
    },
    //vip等級
    vip: {
        level: 'VIP等級',
        grade: '等級',
        reached: '達成條件',
        tips: '提現次數',
        deposit: '存款',
        Valid: '有效投注',
        Times: '次',
        contact: '聯繫客服',
        download: 'APP下載',
        mobile: "訪問移動端",
        'maintanence': '維護中',
        'gotologin': '您還未登錄請前往登錄',
        copy: '複製',
        copyS: '複製成功',
        copyF: '複製失敗'
    },
    header: {
        text1: '存款',
        text2: '取款',
        text3: '彩金',
        text4: '我的資料',
        text5: '收款方式',
        text6: '游戲記錄',
        text7: '交易記錄',
        text8: '公告信息',
        text9: '退出登錄',
        text10: '首頁',
        text11: '體育',
        text12: '電子',
        text13: '棋牌',
        text14: '彩票',
        text15: '視訊',
        text16: '電競',
        text17: '優惠',
        login: '登錄',
        register: '註冊',
        VIP: '普通用戶'
    },
    footer: {
        con: '政府頒發執照，安全有保障！支持微信，支付寶，銀聯服務，24小時取款，5分鐘到賬！受國際協會認可的合法公司。進行註冊並娛樂前，請確保您年滿18周歲！'
    },
    record: {
        text1: '年 /月 /日',
        text2: '查詢',
        text3: '重置',
        text4: '一條記錄也沒有呢...',
        text5: '複製成功！ ',
        text6: '複製失敗！ '
    },
    gameRecord: {
        title: '遊戲記錄',
        text1: '每條投注的數據將會有一定的時間延遲，僅供參考使用',
        text2: '遊戲平台:',
        text3: '請選擇',
        text4: '投注金額:',
        text5: '時間篩選:',
        text6: '單號',
        text7: '複製',
        text8: '遊戲平台',
        text9: '遊戲名稱',
        text10: '投注時間',
        text11: '派彩時間',
        text12: '投注金額',
        text13: '有效投注',
        text14: '派彩金額',
        text15: '盈虧金額',
        text16: '總投注:',
        text17: '總派金:',
        text18: '總有效投注:',
        text19: '總盈虧金額:'
    },
    tradingRecord: {
        title1: '交易記錄',
        title2: '返水詳情',
        text1: '只可查詢近一個月的交易記錄，如需更多信息請聯繫客服查詢',
        text2: '交易類型：',
        text3: '交易狀態：',
        text4: '交易時間：',
        text5: '返水金額：',
        text6: '選擇時間：',
        text7: '訂單號',
        text8: '交易時間',
        text9: '金額',
        text10: '狀態',
        text11: '支付方式',
        text12: '支付成功',
        text13: '提款方式',
        text14: '出款成功',
        text15: '類型',
        text16: '成功',
        text17: '狀態',
        text18: '返水類型',
        text19: '詳情',

        text20: '活動名稱',
        text21: '存入時間',
        text22: '利率',
        text23: '結息時間',
        text24: '金額',
        text25: '利息',
        text26: '本利總額',
        text27: '已存放',
        text28: '狀態',
        text29: '操作',
        text30: '時間',
        text31: '遊戲平台',
        text32: '遊戲名稱',
        text33: '流水',
        text34: '返水',
        text35: '利息錢包：',
        text36: '總領取利息：',
        text37: '利息寶領取',
        text38: '包含利息',
        text39: '元',
        text40: '利息流水要求：',
        text41: '倍',
        text42: '提前領取',
        text43: '提前領取額度，只能領取部分利息，是否確認提前領取？ ',
        text44: '取消',
        text45: '立即領取',


        text46: '今日',
        text47: '昨日',
        text48: '近7日',
        text49: '近30日',
        text50: '全部',
        text51: '計息中',
        text52: '已到期',
        text53: '已領取',
        text54: '充值記錄',
        text55: '銀行轉賬',
        text56: '提款記錄',
        text57: '返水記錄',
        text58: '其它',
        text59: '利息寶',
        text60: '領取成功！ ',
        text61: '未處理',
        text62: '處理中',
        text63: '充值成功',
        text64: '充值失敗',
        text65: '關閉',
        text66: '待支付',
        text67: '支付中',
        text68: '支付成功',
        text69: '支付失敗',
        text70: '已關閉',
        text71: '線下銀行卡支付',
        text72: '線下二維碼支付',
        text73: '線上支付',
        text74: '手動上分',
        text75: '數值貨幣支付',

        text76: '待支付',
        text77: '支付中',
        text78: '支付成功',
        text79: '支付失敗',
        text80: '支付寶掃碼',
        text81: '微信掃碼',
        text82: '微信H5',
        text83: '支付寶H5',
        text84: '銀聯掃碼',
        text85: '銀聯轉賬',
        text86: '其它',
        text87: '未處理',
        text88: '處理中',
        text89: '提款成功',
        text90: '提款失敗',
        text91: '關閉',
        text92: '待出款',
        text93: '出款中',
        text94: '出款成功',
        text95: '出款失敗',
        text96: '關閉',
        text97: '銀行卡提款',
        text98: '手動下分',
        text99: '數值貨幣提款申請',
        text100: 'origo錢包提款',
        text101: '未處理',
        text102: '處理中',
        text103: '成功',
        text104: '失敗',
        text105: '關閉',
        text106: '待領取',
        text107: '已過期',
        text108: '成功',
        text109: '失敗',
        payChannel1: '線下入款優惠',
        payChannel2: '線上入款優惠',
        payChannel3: '手動上分',
        payChannel4: '手動存款優惠上分',
        payChannel5: '手動返水優惠上分',
        payChannel6: '手動活動優惠上分',
        payChannel7: '自動活動優惠上分',
        payChannel8: '手動下分-存款',
        payChannel9: '手動下分-優惠活動',
        payChannel10: '手動下分-人工存款反水',
        payChannel11: '手動下分-存款優惠',
        payChannel12: '手動上分-優惠活動',
        payChannel13: '手動上分-人工存款返水',
        payChannel14: '手動上分-存款優惠',
        payChannel15: '手動上分-其他',
        payChannel16: '手動上分彩金',
        payChannel17: '活動上分彩金',
        payChannel18: '手動上分彩金-人工存款返水',
        payChannel19: '手動上分彩金-存款優惠',
        payChannel20: '手動上分彩金-優惠活動',
        payChannel21: '手動上分-其他彩金',
        payChannel22: '數值貨幣優惠上分',
        payChannel23: '救濟金上分',
        payChannel24: '救濟金彩金',
        payChannel25: '每日簽到上分',
        payChannel26: '全民返利',
        payChannel27: '其他',
        payChannel28: '利息寶存入',
        payChannel29: '利息寶本金提取',
        payChannel30: '利息寶利息提取',

        payChannel31: '信息認證',
        payChannel32: '周勤獎勵',
        payChannel33: '幸運注單',
        payChannel34: '週年禮金',
        payChannel35: '棋牌獎勵',
        payChannel36: '棋牌救援',
        payChannel37: '千倍百倍',
        payChannel38: '億元回饋',

        interestRecord1: '小時',
        interestRecord2: '領回',
        interestRecord3: '提前領取',
        interestRecord4: '計息中',
        interestRecord5: '已到期',
        interestRecord6: '已領取'
    },
    activationRecord: {
        title: '活動記錄',
        text1: '每條活動的數據將會有一定的時間延遲，僅供參考使用',
        text2: '活動名稱：',
        text3: '請輸入活動名稱',
        text4: '活動時間：',
        text5: '活動名稱',
        text6: '參與時間',
        text7: '操作',
        text8: '查看詳情'
    },
    highRebate: {
        title: '全民返利',
        text1: '累計返利:',
        Vnum: '會員總數：',
        effectiveVnum: '有效會員：',
        text2: '元',
        text3: '滿',
        getConditions2: '元，且有效會員≥',
        getConditions3: '人，即可領取',
        text5: '領取',
        text6: '會員',
        text7: '我的推廣碼',
        text8: '下載推廣碼',
        text9: '我的邀請碼',
        text10: '複製邀請碼',
        text11: '我的推廣地址',
        text12: '複製地址',
        text13: '規則說明',
        text14: '邀請會員',
        text15: '總投注：',
        text16: '累計獲得總返利：',
        text17: '註冊時間：',
        text18: '時間篩選：',
        text19: '會員賬號',
        text20: '註冊時間',
        text21: '總有效投注(元)',
        text22: '返利金(元)',
        text23: '領取返利',
        text24: '元',
        text25: '流水要求：',
        text26: '倍',
        text27: '取消',
        text28: '立即領取',
        messageErr1: '未滿足領取要求，最低領取金額',
        messageErr2: '元,有效會員人數≥',
        messageErr3: '人,領取上限',
        text30: '領取成功!'
    },
    interest: {
        title: '利息寶',
        text1: '存款',
        text2: '年利率：',
        text3: '開放區間：',
        text4: '查看利息寶記錄>',
        text5: '存款總額：',
        text6: '元/可再存入',
        text7: '元',
        text8: '存款筆數：',
        text9: '筆/可再存入',
        text10: '筆',
        text11: '存款金額：',
        text12: '單筆最低額度：',
        text13: '元',
        text14: '預計最高利率',
        text15: '最高可獲利息：',
        text16: '元',
        text17: '購買利率說明',
        text18: '存款',
        text19: '元',
        text20: '最高年利率',
        text21: '小時',
        text22: '年利率',
        text23: '立即存入',
        text24: '存款成功',
        text25: '恭喜你，完成存款操作！您可在 利息寶記錄中查看投注詳情以及 獎金信息！ ',
        text26: '知道了',
        text27: '全部',
        text28: '進行中',
        text29: '未開放',
        text30: '已結束',
        text31: '輸入金額不滿足最低額度！',
        text32: '輸入金額不可大於可再存入金額！',
        text33: '單筆金額超出上限！ ',
        text34: '可再存入筆數不足！ ',
        text35: '存入金額不可為空！ ',
        text36: '未開放',
        text37: '存入提升收益',
        text38: '進行中',
        text39: '存入提升收益',
        text40: '結束申請',
        text41: '查看',
        text42: '結束計息',
        text43: '查看'
    },
    download: {
        text1: '澳門金沙App下載',
        text2: '澳門金沙電腦版下載',
        text3: '澳門金沙客戶端囊括了真人、老虎機、捕魚、街機電玩、體育賽事、棋牌等熱門種類，讓您隨時隨地暢享遊戲的精彩！ ',
        text4: '安卓/IOS客戶端',
        text5: '不再劫持，安全穩定，時時防護，任性暢玩！ ',
        text6: '支持 Windows 7及以上操作系統',
        text7: '電腦版下載',
        text8: 'PT電腦版下載',
        text9: '下載通道暫未開放！ ',
    },
    //warp頁面（首頁頭部）
    warp: {
        chinese: '中文',
        pc: "電腦版",
        help: "新手幫助",
        memberRegister: '免費開戶',
        hello: '你好',
        balance: '餘額',
        money: '資金',
        memberDeposit: '會員存款',
        memberWithdraw: '會員提款',
        transfer: "戶內轉賬",
        message: "站內信",
        sign: "領取返水",
        logout: "退出",
        index: '首頁',
        live: '真人視訊',
        egame: "電子遊藝",
        sport: "體育電競",
        chess: "棋牌遊戲",
        lottery: "彩票遊戲",
        fish: '捕魚遊戲',
        discount: "優惠活動",
        service: "在線客服",
        download: "下載",
        cooperation: "合作專區",
        warpBottom1: '合作機構',
        warpBottom2: "關於澳門金沙",
        warpBottom3: "博彩責任",
        warpBottom4: "規則與聲明",
        warpBottom5: "牌照展示",
        warpBottom6: "常見問題",
        warpBottom7: "VIP俱樂部",
        clearCache: "清除緩存",
        advice: '建議使用IE9+瀏覽器、谷歌瀏覽器、火狐瀏覽器，給您的體驗會更好哦！ ',
        tbh: "澳門金沙",
        right: '版權所有',
        selfHelp: '自助'
    },
    //basic页面
    base: {
        changePsw: '更換密碼',
        safetyLevel: '賬號安全等級',
        phoneBind: "手機綁定",
        emailBind: "郵箱綁定",
        moneyPsw: "資金密碼",
        bankcardBind: "綁定銀行卡",
        vipLevel: "會員VIP等級",
        commonUser: "普通用戶",
        distance: '距離',
        short: "還差",
        yuan: '元',
        system: '系統將在',
        nextWeek: "下週一0點",
        clear: "自動清除本週投注並重新累積",
        open: "開通",
        lowLevel: '低級',
        middleLevel: '中等',
        highLevel: '高級'
    },
    //account頁面（個人資料）
    account: {
        title: "完善個人資料",
        account: "登錄賬號",
        realName: "真實姓名",
        realNameP: '請輸入您常用銀行卡真實姓名',
        nickname: '用戶暱稱',
        phone: '手機號碼',
        qq: '聯繫 QQ',
        birthday: '會員生日',
        qqP: "請輸入您的常用QQ",
        wechat: "聯繫微信",
        wechatP: "請輸入您的常用微信",
        email: "會員郵箱",
        emailP: "請輸入您的常用郵箱（注意：郵箱可以幫助您找回登錄密碼）",
        confirm: '確 定'
    },
    'help': {
        'titel1': '關於澳門金沙',
        'titel2': '澳門金沙成立於2009年，持有菲律賓政府頒發的網絡博彩運營執照，同時也是網絡博彩委員會制定有合法博彩牌照的網絡博彩網站，是正規合法對外營業的專業賭場。公司與亞遊（Asia Gaming）,波音（BBIN）, PT（PlayTech），MG（MicroGaming）進行技術合作，共同打造高品質的遊戲平台，具有絕對的合法性和公平性。為廣大客戶提供豐富多彩的博彩活動，並提供豐厚的優惠回饋。 ',
        'titel3': '誠信經營',
        'titel4': '公司嚴格遵守菲律賓政府規定博彩守則，以“誠”為本。 100%信譽保證遊戲公平、公正。您的每筆存取款業務在經過審核後都將安全、快捷的完成',
        'titel5': '公平公正',
        'titel6': '真人娛樂中的荷官均接受嚴格的國際賭場專業訓練與認證，所有賭局都依據荷官動作做出反應，而不是無趣的電腦機率預設結果。我們運用高科技的網絡直播技術，帶給您親歷賭場的刺激體驗。電子遊藝使用最公平的隨機數產生機率，讓您安心享受多元，炫麗的娛樂性遊戲。 ',
        'titel7': '安全與隱私',
        'titel8': '為了客戶的網絡安全，公司成立網絡安全維護中心，並獲得GEOTRUST國際認證，確保網站公平公正。而在遊戲投注中，我們採用128位SSL加密傳輸系統，MD5加密保護為遊戲平台和客戶信息提供進一步保護。我們承諾，將繼續不遺餘力地嚴格實行保密和隱私製度，確保個人資料的安全，並保證不將您的資料洩露給任意一方。 ',
        'titel9': '友善和專業的客戶服務團隊',
        'titel10': '我們親切友善的客服專員訓練有素，在幫助解決客戶疑難的同時也能給與您最優越和最貼身的服務。我們也有提供線上聊天的功能，讓客戶們能即時聯絡我們。 ',
        'titel11': '常見問題',
        'titel12': '一．澳門金沙註冊',
        'titel13': '1.如何註冊澳門金沙真錢賬戶？ ',
        'titel14': '點擊網頁右上角“免費開戶”按鈕，根據彈出頁面需求,填寫真實有效的信息後，澳門金沙後台系統將自動生成賬戶。如在此過程中產生任何問題，請立即聯繫澳門金沙客服人員。 ',
        'titel15': '2.如何登錄澳門金沙遊戲？ ',
        'titel16': '您可以登錄官方網址或通過客戶端，登錄澳門金沙的遊戲頁面。 ',
        'titel17': '3.有沒有試玩？ ',
        'titel18': '我們提供免費試玩賬號，讓您了解以及熟悉我們的遊戲平台和遊戲種類，如果對我們遊戲平台滿意的話可以存款進行真錢遊戲。 （備註：試玩彩金僅供試玩，不參與提款）',
        'titel19': '4.為何無法正常瀏覽澳門金沙網站',
        'titel20': '澳門金沙網站在無法抗拒因素干擾時可能會導致您無法正常瀏覽網站，如遇此類情況請立即聯繫澳門金沙客服人員。 ',
        'titel21': '5.澳門金沙客戶遊戲年齡限制',
        'titel22': '澳門金沙真錢賬戶年齡最低限制為21歲，凡21歲以下，澳門金沙謝絕註冊！ ',
        'titel23': '二．澳門金沙賬戶',
        'titel24': '1.如何更改註冊信息',
        'titel25': '澳門金沙必須使用真實姓名註冊，一旦註冊成功，姓名和賬號無法更改；銀行卡信息和密碼可以在【會員中心】自行更改，如在此過程中遇到任何問題，可以隨時聯繫澳門金沙客服。 ',
        'titel26': '2.忘記密碼怎麼辦？ ',
        'titel27': '澳門金沙共有2個密碼。一個是您進入網站或者遊戲的登錄密碼，另外一個是提款時使用的安全密碼。 ',
        'titel28': 'A.登錄密碼忘記：點擊網站右上角的“忘記密碼”：',
        'titel29': '1.通過輸入安全密碼來重置登錄密碼',
        'titel30': '2.通過您註冊資料綁定的郵箱重置登錄密碼；',
        'titel31': '3.通過您遊戲賬號綁定的手機來找回登錄密碼；',
        'titel32': 'B.安全密碼忘記：',
        'titel33': '1.請先登錄您的賬號，進入【會員中心】>【安全管理】>【安全密碼】，通過設置安全問題重置安全密碼；',
        'titel34': '2.通過遊戲賬號綁定的手機重置安全問題，重設安全密碼。 ',
        'titel35': '3.如何完成存款',
        'titel36': 'A．存款',
        'titel37': '自您成功註冊賬號之後，您就可以開始存款業務。目前為止澳門金沙接受：“掃碼支付” “在線支付”，“微信支付”，“支付寶轉賬”，及“網銀轉賬/ATM及櫃檯”等存款方式。請您根據實際情況，選擇最合適的存款方式。 ',
        'titel38': 'B．完成存款之後多久可以添加到賬戶中？ ',
        'titel39': '根據您選擇的存款方式的不同，金額到帳時間也會有所不同，一般都是即時到帳。如遇問題請聯繫澳門金沙客服人員。 ',
        'titel40': 'C．存款之後是否有投注要求？ ',
        'titel41': '在您完成存款之後，在您沒有領取任何獎金的情況下，您只需要完成存款額一倍的投注額，即可申請提款。 ',
        'titel42': '4.如何完成提款',
        'titel43': 'A．提款',
        'titel44': '在您的賬號完成所有投注要求之後，您可以在【財務中心】的【會員提款】填寫資料後提交申請，相關部門會立刻為您處理；申請提款時，請務必填寫真實銀行信息。提款一般5分鐘內可以到帳。 ',
        'titel45': 'B．提款為什麼被拒絕？ ',
        'titel46': '提款業務被澳門金沙相關部門退回之後，請您立即聯繫澳門金沙客服諮詢。 ',
        'titel47': '5.如何戶內轉賬？ ',
        'titel48': '登錄賬號以後，電腦網頁版點擊右上角“資金-戶內轉賬”，手機網頁版點擊首頁下方“轉賬”，選擇相應的遊戲廳，遊戲時選擇“轉入遊戲平台”，提款時選擇“轉入主賬戶”。 ',
        'titel49': '三．澳門金沙遊戲',
        'titel50': '1.澳門金沙提供多少款遊戲？ ',
        'titel51': '澳門金沙目前提供多平台高支付遊戲，包含：',
        'titel52': '2.進入遊戲很慢怎麼辦？ ',
        'titel53': '如果您進入我們的網站或遊戲過於緩慢，建議您清除下緩存！ IE和360瀏覽器的步驟為：',
        'titel54': '1.請您先退出我們的網站。 ',
        'titel55': '2.點擊瀏覽器右上角“工具”選擇“Internet選項”，再點擊“刪除”，勾選“Cookie和網站數據”並點擊刪除，等待刪除完成後請再次嘗試進入遊戲！ ',
        'titel56': '關於3.遊戲中視頻無法顯示怎麼辦？澳門金沙',
        'titel57': '建議您可以清除您的FLASH 緩存，請您點擊這個鏈接網址：',
        'titel58': '然後點擊“刪除所有WEB站點”。在彈窗中點擊“確認”即可完成操作！ ',
        'titel59': '4.手機可以玩遊戲嗎？ ',
        'titel60': '目前網站支持安卓和蘋果手機，您可以使用網頁遊戲或者下載客戶端遊戲。但是就算是在WIFI的環境下，目前手機處理器的運行能力還是有限，有時會出現畫面卡頓的情況。所以建議還是用電腦運行遊戲！ ',
        'titel61': '5.如何產生遊戲結果並保證遊戲的公平性？ ',
        'titel62': '澳門金沙所有遊戲結果均由遊戲供應商所產生，遊戲結果真實有效，澳門金沙會對所有的遊戲結果負責。真人娛樂中的荷官均接受嚴格的國際賭場專業訓練與認證，所有賭局都依據荷官動作做出反應，而不是無趣的電腦機率預設結果。電子遊藝使用最公平的隨機數產生機率，讓您安心享受多元，炫麗的娛樂性遊戲。 ',
        'titel63': '6.如何下注，撤銷投注，查詢遊戲記錄？ ',
        'titel64': '澳門金沙所有遊戲下注均在遊戲頁面擁有醒目下注按鈕，根據您的投注習慣下注即可。老虎機類游戲無法撤銷投注，一經點擊遊戲自動開始，請妥善點擊。真人現場類或體育競技類游戲在投注未被接受之前，可以選擇取消投注。所有遊戲記錄均可在遊戲頁面菜單中查詢。如遇任何問題，請隨時聯繫澳門金沙客服人員。 ',
        'titel65': '7.為什麼投註記錄中的有效投注額和你們統計的不一致呢？ ',
        'titel66': 'AG平台和波音平台都是採用的美東時間（美國東部時間如：紐約、華盛頓時間）所以投註記錄中的時間會和實際投注時間有差別。例如實際投注時間為當天晚上20:00則記錄上顯示的時間為當天早上8:00，有12個小時的時差。 MG採用的格林威治時間，和北京時間有8個小時時差。 ',
        'titel67': '8.真人現場遊戲是實時遊戲嗎？遊戲頁面是否作假？ ',
        'titel68': '澳門金沙真人現場遊戲提供商為Playtech、AG、Microgaming、BBIN，其旗下所有真人現場遊戲均為實時遊戲。 PT牌桌旁邊電視中播放美國CNN電視台或者其他著名電視台全球同步的節目，此外您還可以隨時與真人現場荷官聊天；AG您可以撥打桌面的菲律賓電話進行實時通話。 ',
        'titel69': '9.如果遊戲突然中斷遇突發狀況我該怎麼辦？ ',
        'titel70': '澳門金沙遊戲經過不斷完善已經在同行業中屬於極為穩定的遊戲環境。但是由於國際網絡，客戶所在國家地區等諸多不可控制因素干擾，遊戲有可能會突然中斷。如遇到此類問題，請勿驚慌焦躁，立即聯繫澳門金沙客服人員協助處理。在此澳門金沙鄭重承諾，凡是由於澳門金沙方面造成的遊戲損失，澳門金沙一定會為此負責及賠償！ 。 ',
        'titel71': '四．澳門金沙投注及獎金要求',
        'titel72': '1.澳門金沙如何獲得獎金',
        'titel73': '澳門金沙提供了許多優惠獎金獲取機會，部分獎金是您無需申請，自動添加至您的賬戶中，另外一些獎金則需要您申請，通過之後自動為您添加。 ',
        'titel74': '2.可以取消獎金嗎？ ',
        'titel75': '在您賬戶獲得獎金之後，是無法取消的。 ',
        'titel76': '3.沒有完成投注要求是否可以提款？ ',
        'titel77': '澳門金沙所有真錢賬戶在沒有完成相應獎金投注要求之前，謝絕提款業務。如果您的賬戶餘額低於5元人民幣時，之前的所有投注要求將會自動清零。 ',
        'titel78': '聯繫我們',
        'titel79': '澳門金沙客服部',
        'titel80': '澳門金沙客服部是指定對客服務部門，客服部工作性質為24小時線上服務，其服務溝通渠道包含“在線客服”“熱線”“QQ客服”及“投訴與建議” 。如果您在澳門金沙遊戲中遇到任何問題，您可以通過以下方式聯繫客服人員尋求幫助，客服部專業24小時客服人員竭誠為您服務！ ',
        'titel81': '溫馨提示：',
        'titel82': '以下聯繫方式為澳門金沙指定服務通道，如遇到冒充、偽造或未經證實的溝通案例，請勿相信其任何內容，並且請您及時聯繫本公司客服人員核實或反映情況！在此聲明，如客戶在虛假服務中受到任何損失，恕本公司概不負責！感謝您的支持幫助與理解！ ',
        'titel83': '在線聊天包含:',
        'titel84': '1. 官方在線客服。 ',
        'titel85': '2. 營銷QQ客服：1579010。 ',
        'titel86': '2. 官方熱線：0063-9695-600000',
        'titel87': '3. 建议及投诉邮箱：cs@sanos8888.com',
        'titel88': '規則與聲明',
        'titel89': '本公司是合法互聯網交易機構，現提醒有意參與本公司所有遊戲之客戶，應注意其國家或居住地區的相關法律規定，如有疑問，應就相關問題尋求當地法律意見。本條款涵蓋您與本公司，在本網站進行博彩行為時的所有協議。 ',
        'titel90': '1、法定要求',
        'titel91': '根據您所居住國的法律，您必需達到法定年齡，您才可使用本網站。 ',
        'titel92': '如果您尚未年滿21歲，在任何情況下您都不可使用本網站。 ',
        'titel93': '部份地區或國家法律尚未明確在線博彩的合法性問題，甚至某些地區或國家已明確規範在線博彩為非法行為。我們無意邀請任何人在這些地區或國家非法使用本網站。本網站的存在並不表示我們推廣在線博彩於任何賭博非法的地區或國家。您必需確定在您所居住的地區或國家使用在線博彩是否合法，並負完全的責任。 ',
        'titel94': '2、帳戶規定',
        'titel95': '客戶只能擁有一個賬號，如發現客戶擁有多個賬號，本公司有權凍結客戶的賬號以及取消該賬號內所有勝出的投注。本公司有權保留取消任何因素導致賬號結餘不正確的金額。此外如發現賬號持有人與親屬共同使用多個不同賬號，本公司有權限制客戶每人各保留最多一個賬號。若上述情形已構成欺詐、危害或侵犯本公司及其它用戶權利或利益時，本公司有權要求該用戶賠償並沒收用戶帳戶中所存之餘額，終止或註銷用戶繼續使用本系統的權利',
        'titel96': '3、交易結算',
        'titel97': '用戶有責任及義務在每次遊戲交易之前或之後及離開遊戲前，檢查自己的賬戶餘額。當用戶懷疑餘額有錯誤時，必需在進行下一回合的遊戲（遊戲開始到結賬畫面出現視為一個回合）前，向本網站在線客服人員或本公司客服部人員提出申訴。如果您不這麼做，本公司將視為您放棄提出申訴的權利，並接受目前的餘額數據為正確。 ',
        'titel98': '直接與本公司交易結算的用戶，銀行帳戶名稱須與會員登記和申請過程中所使用的姓名一致。若用戶使用信用卡或借記卡時，持卡人姓名亦須與會員登記和申請過程中所使用的姓名一致。若發生銀行賬戶名稱或持卡人姓名和賬戶登記(會員註冊)時所使用的姓名不一致時，本公司有權拒絕相關交易的結算',
        'titel99': '用直接與本公司交易結算的用戶，本公司會依據用戶所提供的交易方式信息，將博彩所得存入您的用戶帳戶中。任何款項或所得在存入賬戶的過程中，若因為用戶所提供的信息不足或信息錯誤而發生交易錯誤的情形時，本公司不負任何形式的責任。用戶一旦發現帳戶內款項有誤時，有責任立即通知我們。 ',
        'titel10': '本公司因用戶的結算交易而蒙受的銀行費用，包括手續費、電郵費等，本公司有權從用戶的帳戶餘額中扣除和抵扣上述費用。 ',
        'name1': 'JACKPOT 中獎後將根據具體中獎金額扣取一定的獎池管理費，具體以遊戲平台公司的收取金額作為依據。 ',
        'name2': '4、本公司之權利與義務',
        'name3': '本公司會採取各種措施保護玩家的賬戶安全。 ',
        'name4': '本公司絕不會以任何人為的手段，影響遊戲的公正性。 ',
        'name5': '本公司對非法使用玩家賬戶的行為不負任何責任。 ',
        'name6': '本公司保留修改所有製度及規則條款的權利。 ',
        'name7': '本公司若發現玩家在遊戲中，有作弊、攻擊或破壞本系統正常操作以及使用明確表示或暗示的方式以與事實不符、莫須有之說針對「澳門金沙娛樂城」詆毀、漫罵、恐嚇、毀謗的行為，經公司勸阻不止，本公司保留拒絕/禁止和吊銷玩家繼續使用本系統的所有權利，"並將依菲律賓共和國法律進行追訴"。 ',
        'name8': '本公司對於您個人的數據及在系統中進行的記錄，皆有「備份數據」。但若不幸發生不可抗拒之因素（如天災、恐怖活動、戰爭、暴動…）導致上述數據遺失時，本公司會盡全力恢復所有的歷史數據，所恢復的數據也將視為公正。 ',
        'name9': '5、促銷和優惠',
        'name10': '所有促銷、優惠和特別活動均須遵守本條款及本公司針對具體優惠活動所不時制定的規則與條款。本公司保留在任何時候中止、取消或修改該等促銷、獎勵和特別活動之相關規定及條款的權利。 ',
        'name11': '若本公司認定有人濫用或企圖濫用某項促銷或獎勵活動，或可能因該等濫用行為而獲利時，本公司有權自主決定以其認為合適的方式阻止、拒絕、中止或撤銷任何用戶參加有關的促銷、獎勵和特別活動。 ',
        'name12': '6、條款修改政策',
        'name13': '本公司保留不時修訂、更新和修改本條款和遊戲規則的絕對權力。任何修訂、更新和修改將在官網上公佈。經修訂、更新或修改的本條款和遊戲規則，在公佈時即生效。用戶在上述修訂、更新和修改公佈後，繼續使用本網站或遊戲時，則視為用戶同意並接受本公司的修訂、更新和修改。 ',
        'name14': '我們建議您定期閱讀本網站之規則與條款及遊戲規則。 ',
        'name15': '上述修訂、更新和修改，本公司可自行決定是否通知用戶。本公司並無任何義務向用戶通知上述之修訂、更新和修改。 ',
        'name16': '会员存款',
        'name17': '綠色通道',
        'name18': '支付寶轉銀行卡',
        'name19': '銀聯掃碼',
        'name20': '博彩責任',
        'name21': '牌照展示',
        'name22': '防劫持幫助',
        'name23': '存款演示',
        'name233': '取款演示',
        'name24': '一. 防劫持說明',
        'name25': '如果您使用移動設備訪問我們網站的地址，打開網頁後跳轉至其他的網站。應該如何處理？ ',
        'name26': '這是屬於DNS劫持情況，DNS簡稱域名劫持，是屬於被網絡黑客利用了服務器的漏洞，更改了您的域名原IP，然後跳轉至其他假網站。可能引起您失誤操作，甚至會危害到您的賬戶和財產安全。 ',
        'name27': '二. 操作說明',
        'name28': '安卓客戶端',
        'name29': 'IOS客戶端',
        'name30': '澳門金沙是在菲律賓擁有合法經營權的機構, 其確保澳門金沙運營的公正性和合法性，從而保障了客戶與澳門金沙之間的公平、公正及資金安全！ PT遊戲是由PT TransPacific在PAGCOR的授權下部署。 ',
        'name31': 'CEZA認證',
        'name32': 'PAGCOR認證',
        'name33': '執照號碼OGL16-0014',
        'name34': '未滿博彩年齡',
        'name35': '本公司是合法互聯網交易機構，現提醒有意參與本公司所有遊戲之客戶，應注意其國家或居住地區的相關法律規定，如有疑問，應就相關問題尋求當地法律意見。本條款涵蓋您與本公司，在本網站進行博彩行為時的所有協議。 ',
        'name36': '澳門金沙娛樂城積極推行負責任博彩，並極力拒絕未成年玩家使用我們的軟體進行網上娛樂。同時，我們更通過專業人員及各種有效方法，以防止問題博彩的發生。一旦發現使用該本網站的客戶未滿21歲，我們將會沒收所有贏取的彩金並保留立即終止客戶的投注戶口操作的權利。 ',
        'name37': '本服務不提供給未滿21歲之任何人士。所有使用本服務的人士所提供的數據顯示其年齡已滿21歲。如本公司認知未滿21歲之人士嘗試或已提供數據給予本網站，本公司將不接受其數據並採取清除其數據的動作。 ',
        'name38': '如您的電腦被未滿21歲的人士使用， 我們建議您設定電腦資料保密以防止帳戶號碼/用戶名稱被盜用。 ',
        'name39': '博彩行為檢視',
        'name40': '博彩只是一種娛樂，大部分玩家視博彩為消閒娛樂。然而小部分玩家無法自製，沉迷於賭博，往往對自己及社會均造成傷害。以下是為玩家準備的博彩問題測試，閣下可以測試是否面臨以下的問題。 ',
        'name400': '1.您是否因為博彩而不上班或不上學？ ',
        'name41': '2.您博彩是否為了逃避煩悶或不愉快的生活？ ',
        'name42': '3.當您博彩花光錢時，您是否感到失望甚至絕望，並且希望馬上能再進行賭博？ ',
        'name43': '4.您會否博彩到最後一分錢才罷休？ ',
        'name44': '5.您有否曾經用謊言掩飾您花在博彩上的時間和金錢？ ',
        'name45': '6.您博彩是不是因為爭執，沮喪或失望？ ',
        'name46': '7.您有沒有因為博彩而感到失落甚至輕生？ ',
        'name47': '8.您是否對您的家人，朋友或愛好失去了興趣？ ',
        'name48': '9.您輸了之後，是否馬上想把輸的錢贏回來？ ',
        'name49': '在這些問題中您回答的‘是’越多，您就越接近具備嚴重博彩問題。 ',
        'name50': '為了協助您判定所設定的限制是否合適於您，請仔細考慮：',
        'name51': '1.在還未開始博彩之前製定一個可以接受的輸贏額度',
        'name52': '2.留意您花費多長時間在博彩遊戲',
        'name53': '3.按您實際情況制定一個您每天、每週或每月的投注額度',
        'name54': '責任感和正直誠信',
        'name55': '澳門金沙娛樂城致力於提高服務水準，並承諾向客戶履行最大程度上的責任，包括誠信、透明度、合法性等各方面。如客戶遇上任何有關責任博彩的問題，可24小時向我們的客戶服務部聯絡。我們承諾會於一年365日，不間斷地為用戶提供技術支援及相關問題解答服務。 ',
    },
    //棋牌奖励
    Reward: {
        title: '棋牌獎勵金',
        table1: '日期',
        table2: '完成總局數',
        table3: '有效投注額',
        table4: '獎勵金',
        receive: '領取',
        receive1: '已領取',
        receive2: '未達成領取條件',
        footer1: '溫馨提示：',
        footer2: '1. 根據會員每日在開元棋牌、761棋牌、三國棋牌、大富翁棋牌平台所完成的遊戲總局數， 且當天在上述棋牌平台的總有效投注額≥1000元，即會返送相對應的獎勵金',
        footer3: '2. 每日16點前，統計昨日北京時間00點--23點59分59秒產生的總局數。 ',
        footer4: '3. 每日活動的獎勵金不可累積，如用戶在某一天未領取獎勵金，則視為自動放棄該獎勵將清零重新統計。 ',
        footer5: '4. 活動禮金不限遊戲，只需1倍流水即可提款。 ',
        footer6: '5. 溫馨提示： ',
        footer7: '點擊此處查看',
        footer8: '棋牌獎勵金優惠詳情',
        message1: '領取成功！ ',
        message2: '獎勵已領取！ ',
        text1: '月',
        text2: '日',
    },
    //棋牌救援
    Rescue: {
        title: '棋牌救援金',
        table1: '日期',
        table2: '負盈利',
        table3: '獎勵金',
        receive: '領取',
        receive1: '已領取',
        receive2: '未達成領取條件',
        footer1: '溫馨提示：',
        footer2: '1. 活動期間，根據會員每日在開元/761/三國/大富翁棋牌的負盈利，即可獲得對應的救援金！ ',
        footer3: '2. 活動時間：2018-08-01起，長期有效',
        footer4: '3. 每日中午12點前，統計昨日北京時間00點--23點59分59秒產生的負盈利。 ',
        footer5: '4. 每日活動的救援金不可累積，如用戶在某一天未領取，則視為自動放棄該救援金，第二日將清零重新統計。 ',
        footer6: '5. 溫馨提示： ',
        footer7: '點擊此處查看',
        footer8: '棋牌救援金優惠詳情',
        message1: '領取成功！ ',
        message2: '獎勵已領取！ ',
        text1: '月',
        text2: '日',
    },
    //自助优惠---周年礼金 + 千倍万倍页面
    Anniversary: {
        tip1: '溫馨提示：如您在周年禮金領取日開始之前累積存款未達到 1 元，將無法獲得此優惠！ ',
        tip2: '發放時間：首次存款日期開始，每滿一整年後隔日凌晨1:30分開始發放！ ',
        tip3: '未滿足參與條件，沒有首存款',
        tip4: '領取',
        tip5: '已領取',
        tip6: '【查看優惠詳情】',
        tip7: '恭喜您成功領取',
        tip31: '獎勵，請注意賬戶餘額變動',
        tip8: '溫馨提示：每天（00:00至當天23:59:59）只能領取一次千百倍獎金！ （提交錯誤信息超過5次，取消當日申請資格）',
        tip9: '千倍萬倍',
        tip10: '遊戲平台',
        tip11: '遊戲時間',
        tip12: '投注額',
        tip13: '中獎倍數',
        tip14: '獲得獎金',
        tip15: '備註',
        tip16: '操作',
        tip17: '申請獎勵',
        tip19: '暫無中獎紀錄',
        tip20: '溫馨提示',
        tip21: '如遇網絡因素不顯示當前符合的注單，請稍後刷新網絡後重試或點擊下面的自助提交',
        tip22: '*CQ9、DT、AE、TTG 等平台，請點擊！ ',
        tip23: '自助提交投訴建議。 ',
        tip24: '1. 當遊戲的中獎牌局總派彩為投入額',
        name2: '百倍',
        name3: '以上時派發的獎金，滿足條件的會員可自助申領',
        tip25: '2. 活動時間：2019年3月14日至2020年6月1日(00:00:00-23:45:00)。 ',
        tip26: '3. 每位用戶每天只可領取',
        name: '次千百倍獎金，如當日未領取，則視為自動放棄該獎勵，第二日將清零重新統計。 ',
        tip27: '（注意：不包括平台中的捕魚游戲、現場莊家、視頻撲克、街機遊戲、牌桌遊戲和刮刮樂等遊戲。)',
        tip28: '4. 活動禮金不限遊戲，只需12倍流水即可提款。 ',
        tip29: '點擊此處查看',
        tip30: '是否確認申請該注單獎勵',
        tip33: '提示',
        tip32: '確定',
        tip34: '取消',
        tip35: '未滿足領取條件',
        tip36: '沒有首付款',
        tip37: '週年禮金',
        tip38: '點擊關閉即返回自助大廳',
        tip39: '第一次存款日期',
        tip40: '當前VIP等級',
        tip41: '預發放週年禮金',
        tip42: '這裡',
        tip43: '千倍百倍優惠詳情。 ',
        tip44: '距滿年時間還有',
        tip45: '溫馨提示',
        tip46: '沒有首存款',
        tip47: '確定',
        tip48: '已領取',
    },
    //自助優惠-周勤獎勵
    weekAward: {
        title: "周勤獎勵",
        topTips: "溫馨提示：每天14點統計更新上一天的有效投注額！",
        thisWeek: '本週周勤',
        lastWeek: '上週周勤統計',
        thisTurnDayCount: '本週已出勤',
        day: '天',
        thisTotalEffeBetsAmount: '累計有效投注額',
        yuan: '元',
        lookLastRecords: "【查看上週記錄】",
        lastTurnDayCount: '上週累計出勤天數',
        lastTotalEffeBetsAmount: '上週累積的有效投注額',
        weekGift: '周勤禮金',
        seeGift: '獎勵一覽',
        keepOnFighting1: '上週未達到發放條件',
        keepOnFighting2: '本週請繼續努力',
        keepOnFighting3: "您上週已達到發放條件",
        keepOnFighting4: "請注意餘額變動",
        botTips: "溫馨提示：",
        botTip1: "1. 活動介紹：澳門金沙會員只要在一周內，累計四天有進行遊戲投注，且這四天之中，每日有效投注額不小於300元，周有效投注額不小於5000元，即可獲得相應的周勤獎金！",
        botTip21: "2. 發放時間：",
        botTip22: "每週二14:00",
        botTip23: '之前，系統會完成',
        botTip24: '上一周',
        botTip25: '投注情況的統計，達到條件的會員會在',
        botTip26: "18：00之前",
        botTip27: '由系統發放 。 ',
        botTip3: "3. 【首存優惠】和【周勤禮金】優惠不能在同一周且不能同時享受。",
        botTip4: "4. 需要八倍流水才可提款。",
        botTip5: '5. 該活動若存在文字理解的差異，則最終解釋權歸【澳門金沙】所有，且【澳門金沙】有權更改、結束、縮短、延長該活動。 ',
        weekGiftTableLabel1: "週出勤(單日投注>300)",
        weekGiftTabelLabel2: '周有效投注額（元）',
        weekGiftTabelLabel3: '周勤禮金（元）',
        weekGiftCalcu: '周勤獎勵禮金計算',
        lastWeekAwardCalcu: '上週周勤記錄',
        minSignDay: '最低',
        through: "至",
        unget: "領取獎勵",
        geted: "已領取"
    },
    //幸運注單
    luckyNote: {
        title: '幸運注單',
        topTips1: '溫馨提示：每天（00:00至當天23:59:59）只能領取',
        topTips2: '次幸運注單！每個注單號只能申請一次！ （提交錯誤信息超過5次，取消當日申請資格）',
        platForm: '電遊平台',
        gameTime: '遊戲時間',
        betMoney: '下注金額',
        luckyNoteNum: '幸運注單號',
        actGift: '活動禮金',
        operation: '操作',
        apply: '申請',
        applyed: "已申請",
        middleTips: '如遇網絡因素不顯示當前符合的注單，請稍後刷新網絡後重試或點擊下面的自助提交',
        text1: "*幸運注單自動查詢",
        text2: "不支持DT平台",
        text3: "，如有需要請在",
        text4: "這裡",
        text5: '自助提交',
        applyRecords: "今日申請記錄",
        clickThis: "點擊此處查看",
        luckyNotedetail: '幸運投注優惠詳情',
        applyTime: '申請時間',
        applyPlatForm: '申請平台',
        betNum: '投注單號',
        awardMoney: '洗碼獎勵金額',
        effBetMoney: '洗碼有效投注額',
        remarks: '備註',
        isConfirmApply: "是否確認申請該注單獎勵？",
        confirm: '確認',
        cancel: '取消',
        applySuccess1: '恭喜您成功領取',
        applySuccess2: "獎勵，請注意賬戶餘額變動！",
        applyFail: '未滿足領取條件',
        emptyText1: "--暫無記錄--",
        emptyText2: "暫無數據",
    },
    //信息認證
    credentials: {
        title: '信息認證',
        name: '信息認證紅利',
        bank1: '銀行卡驗證',
        pawess: '安全密碼驗證',
        text1: '歷史累計存款',
        text2: '元',
        text3: '認證紅利（元）',
        text4: '用戶需完成上述所有認證並審核通過後，才能夠領取此紅利',
        text5: '[完善認證]',
        text6: '未滿足領取條件',
        text7: '提示：',
        text8: '溫馨提示：',
        text9: '1. 用戶必須完成通過所有認證以及歷史累計存款不小於',
        text9: '元後，才達到申領條件！',
        text10: '2. 每個賬戶只允許申領一次信息認證紅利。 ',
        text11: '3. 如您對此還有疑問，可點擊查看',
        text12: '認證紅利',
        text13: '規則。 ',
        failed: '未達到領取要求',
        received: '領取',
        receivedt: '已領取',
        'realName': "姓名",
        'email': "綁定郵箱",
        'phone': "綁定手機號",
        'qq': "綁定QQ號",
        'safePassword': "安全密碼驗證",
        'bank': "銀行卡綁定",
        'digitalCurrency': "綁定數字貨幣",
        'origin': "綁定錢包",
        'deposit': "累計存款",

    },
    //億元回饋
    feedback: {
        title: '億元回饋',
        state: '開始日期',
        storp: '結束日期',
        table1: '出款流水',
        table2: '盈虧預算',
        table3: '獎勵金額',
        table4: '操作',
        tips: '溫馨提示：',
        text1: '如遇網絡因素不顯示當前符合的注單，請稍後刷新網絡後重試或點擊下面的自助提交',
        text2: '請點擊 ',
        text3: '這裡',
        text4: '自助提交投訴建議。 ',
        text5: '1. 活動對象：所有澳門金沙普通VIP及以上的會員。 ',
        text6: '2. 所獲禮金1倍流水出款。 ',
        text7: '3. 領取時間：每月1日、11日、21日，即可領取。 ',
        text8: '4. 此活動可以澳門金沙所有優惠同時共享。 ',
        text9: ' 5. 所有客戶只能擁有一個賬號：同一個IP、同一個存/提款卡、同一個手機號碼、同一個郵箱都視為同一個客戶， 如果發現同一個擁有兩個或以上的賬戶，重複的賬戶將會被凍結，【澳門金沙】保留索回重複賬戶的獎勵及盈利的權利。 ',
        text10: '6. 參與該優惠，即表示您同意《優惠規則與條款》。 ',
        text11: '點擊此處查看',
        text12: '優惠詳情。 ',

    },
};
export default zh_HK;